import { render, staticRenderFns } from "./order.vue?vue&type=template&id=406a4f3e&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=406a4f3e&prod&lang=less&scoped=true"
import style1 from "./order.vue?vue&type=style&index=1&id=406a4f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a4f3e",
  null
  
)

export default component.exports